import template from "./log-in-page.html";

const LogInPageComponent = {
  template: template,

  controller: class LogInPageController {
    /* @ngInject */
    constructor(
      $rootScope,
      $scope,
      $state,
      $timeout,
      $filter,
      $location,
      User,
      SecurityManager,
      GravatarService,
      SweetAlertService,
      Utils,
      moment
    ) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$state = $state;
      this.$timeout = $timeout;
      this.$filter = $filter;
      this.$location = $location;
      this.User = User;
      this.SecurityManager = SecurityManager;
      this.GravatarService = GravatarService;
      this.SweetAlertService = SweetAlertService;
      this.Utils = Utils;
      this.moment = moment;
    }

    $onInit() {
      this.isProd = process.env.ENV === "prod";

      if (this.SecurityManager.isAuthenticated())
        this.$timeout(() => this.$state.go("index"), 100);

      this.loading = false;
      const { email } = this.$location.search();
      this.email = email;
      this.emailResetPassword = null;
      this.showLogin = true;
      this.showTwoFactor = false;
      this.showResetPassword = false;
      this.password = null;
      this.twoFactorCode = null;
      this.rememberMe = false;
      this.skipTwoFactor = true;
      this.error = false;
      this.cardError = false;
      this.tip = this._getRandomTip();
      // this.gravatarPicture = this.GravatarService.getGravatarPicture(
      //   this.email
      // );

      this.$scope.$watch(
        () => this.email,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            // if (newVal)
            //   this.gravatarPicture =
            //     this.GravatarService.getGravatarPicture(newVal);
            this.error = false;
          }
        }
      );

      this.$scope.$watch(
        () => this.password,
        (newVal, oldVal) => {
          if (this.error && !angular.equals(newVal, oldVal)) this.error = false;
        }
      );
    }

    async logIn() {
      this.error = false;
      this.cardError = false;
      if (this.form.$valid) {
        this.loading = true;

        try {
          const user = await this.SecurityManager.authenticate(
            this.email,
            this.password,
            !this.isProd && this.skipTwoFactor
          );
          if (!!user) {
            this._onLogInSuccess(user);
          } else {
            this.showTwoFactor = true;
          }
        } catch (e) {
          this._onLogInError(e);
        } finally {
          this.loading = false;
          this.$rootScope.$applyAsync();
        }
      }
    }

    async logInTwoFactor() {
      this.error = false;
      this.cardError = false;
      if (this.form.$valid) {
        this.loading = true;
        try {
          const user = await this.SecurityManager.authenticateTwoFactor(
            this.email,
            this.password,
            String(this.twoFactorCode)
          );
          this._onLogInSuccess(user);
        } catch (error) {
          this._onLogInError(error);
        }
        this.loading = false;
      }
    }

    goResetPassword() {
      this.showLogin = false;
      this.showResetPassword = true;
      this.showTwoFactor = false;
    }

    goSignUp() {
      this.$state.go("signup");
    }

    goLogin() {
      this.showLogin = true;
      this.showResetPassword = false;
      this.showTwoFactor = false;

      this._resetForm();
    }

    async resetPassword() {
      if (!this.formResetPassword.$valid) return;
      this.loading = true;
      try {
        await this.User.resetPassword(this.emailResetPassword);
        await this.SweetAlertService.resetedPassword(this.emailResetPassword);
      } catch (e) {
        await this.SweetAlertService.errorResetingPassword();
      }

      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    _getRandomTip() {
      return "tip" + Math.floor(Math.random() * 13);
    }

    _resetForm() {
      this.email = null;
      this.password = null;
      this.twoFactorCode = null;
      this.emailResetPassword = null;
      this.form.$setPristine();
    }

    _onLogInSuccess(user) {
      this.SecurityManager.storeCredentials(user.accessToken, this.rememberMe);
      this.$rootScope.user = user;

      if (this.Utils.accessFromMobile()) {
        this.$state.go("accessFromMobile");
      } else {
        if (this.$rootScope.returnToState !== null) {
          const state = this.$rootScope.returnToState.state;
          const params = this.$rootScope.returnToState.params;
          this.$rootScope.returnToState = null;
          this.$state.go(state, params);
        } else {
          this.$state.go("index");
        }
      }
    }

    _onLogInError(e) {
      if (e.data === "Invalid email or password") {
        this.error = this.$filter("trans")(
          "errors.auth.invalidPasswordOrEmail"
        );
      } else if (e.data && e.data.indexOf("Too many failed attempts") !== -1) {
        const nextValidRequestDate = e.data.split("~")[1];
        const nextValidRequestDateText =
          this.moment(nextValidRequestDate).fromNow();
        this.error = this.$filter("trans")("errors.auth.failedAttempts", [
          nextValidRequestDateText,
        ]);
      } else if (e.data === "Invalid login verification code") {
        this.error = this.$filter("trans")("errors.auth.invalidTwoFactorCode");
      } else {
        throw e;
      }

      this.loading = false;

      this.$rootScope.$applyAsync();
    }
  },
};

export default LogInPageComponent;
